import { IApplicationState } from '../../types/redux';

/**
 * Выбирает новости на Главной
 */
export const selectMainNews = ({ mainNews }: IApplicationState) => mainNews;
